var _defs, _polyline, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSticla3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9e418de-6db8-4105-a5ee-5dc282cbb34c",
    "data-name": "sticla_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a543b948-80fa-4a14-8641-cf1e18bf9a97{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:10px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sticla_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a543b948-80fa-4a14-8641-cf1e18bf9a97",
    points: "5 5 5 195 95 195 95 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a543b948-80fa-4a14-8641-cf1e18bf9a97",
    x1: 50,
    y1: 195,
    x2: 50,
    y2: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticla3);
export default __webpack_public_path__ + "static/media/sticla_3.cfe561e329e70c4745e44eac54f569ef.svg";
export { ForwardRef as ReactComponent };